import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import railRouteService from './railRouteService'

const initialState = {
    trackForPreview: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    didFindRoute: false,
    routerRequestLogRecordId: '',
    message: '',
}

export const matchRoute = createAsyncThunk ('routes/matchRoute', async (routeDetails, thunkAPI) => {
    try {
        const token = thunkAPI.getState().auth.user.token
        return await railRouteService.matchRoute(routeDetails, token)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        
        // console.log(error)
        return thunkAPI.rejectWithValue(message)
    }
})

export const railRouteSlice = createSlice({
    name: 'route',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(matchRoute.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
              })
              .addCase(matchRoute.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.didFindRoute = action.payload.didFindRoute
                state.trackForPreview = action.payload.track
                state.routerRequestLogRecordId = action.payload.routerRequestLogRecordId
              })
              .addCase(matchRoute.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.payload
              })
    }
})

export const { reset } = railRouteSlice.actions
export default railRouteSlice.reducer